import * as React from "react";

import getGenePalette from "../getGenePalette";
import GeneSnpShapes from "../shared/GeneSnpShapes";
import { geneGroupProps } from "../shared/geneGroupProps";
import getGeneSnpCount from "../shared/getGeneSnpCount";

export const NutritionOmega3DiagramContent = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick
}) => {
  const fads2 = getGenePalette(geneColors.FADS2);
  const fads1 = getGenePalette(geneColors.FADS1);

  return (
    <>
      <g id="diagram" clipPath="url(#clip1_18284_196607)">
        <rect width={1024} height={1240} transform="translate(0 176)" fill="white" />
        <g id="omega_3-diagram">
          <rect width={1024} height={1240} transform="translate(0 176)" fill="white" />
          <g id="lines">
            <path
              id="Vector"
              d="M512.659 416.7L512.659 416L511.259 416L511.259 416.7L511.959 416.7L512.659 416.7ZM511.959 609L516 602L507.918 602L511.959 609ZM511.959 416.7L511.259 416.7L511.259 602.7L511.959 602.7L512.659 602.7L512.659 416.7L511.959 416.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_2">
            <path
              id="Vector_2"
              d="M512.742 834.7L512.742 834L511.342 834L511.342 834.7L512.042 834.7L512.742 834.7ZM512.042 990L516.083 983L508.001 983L512.042 990ZM512.042 834.7L511.342 834.7L511.342 983.7L512.042 983.7L512.742 983.7L512.742 834.7L512.042 834.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_3">
            <mask id="path-21-inside-1_18284_196607" fill="white">
              <path d="M562 789L562 642L631 642L631 789L562 789Z" />
            </mask>
            <path
              d="M631 642L631.7 642L631.7 641.3L631 641.3L631 642ZM631 789L631 789.7L631.7 789.7L631.7 789L631 789ZM562 789L562 789.7L563.917 789.7L563.917 789L563.917 788.3L562 788.3L562 789ZM567.75 789L567.75 789.7L571.583 789.7L571.583 789L571.583 788.3L567.75 788.3L567.75 789ZM575.417 789L575.417 789.7L579.25 789.7L579.25 789L579.25 788.3L575.417 788.3L575.417 789ZM583.083 789L583.083 789.7L586.917 789.7L586.917 789L586.917 788.3L583.083 788.3L583.083 789ZM590.75 789L590.75 789.7L594.583 789.7L594.583 789L594.583 788.3L590.75 788.3L590.75 789ZM598.417 789L598.417 789.7L602.25 789.7L602.25 789L602.25 788.3L598.417 788.3L598.417 789ZM606.083 789L606.083 789.7L609.917 789.7L609.917 789L609.917 788.3L606.083 788.3L606.083 789ZM613.75 789L613.75 789.7L617.583 789.7L617.583 789L617.583 788.3L613.75 788.3L613.75 789ZM621.417 789L621.417 789.7L625.25 789.7L625.25 789L625.25 788.3L621.417 788.3L621.417 789ZM629.083 789L629.083 789.7L631 789.7L631 789L631 788.3L629.083 788.3L629.083 789ZM631 789L631.7 789L631.7 786.958L631 786.958L630.3 786.958L630.3 789L631 789ZM631 782.875L631.7 782.875L631.7 778.792L631 778.792L630.3 778.792L630.3 782.875L631 782.875ZM631 774.708L631.7 774.708L631.7 770.625L631 770.625L630.3 770.625L630.3 774.708L631 774.708ZM631 766.542L631.7 766.542L631.7 762.458L631 762.458L630.3 762.458L630.3 766.542L631 766.542ZM631 758.375L631.7 758.375L631.7 754.292L631 754.292L630.3 754.292L630.3 758.375L631 758.375ZM631 750.208L631.7 750.208L631.7 746.125L631 746.125L630.3 746.125L630.3 750.208L631 750.208ZM631 742.042L631.7 742.042L631.7 737.958L631 737.958L630.3 737.958L630.3 742.042L631 742.042ZM631 733.875L631.7 733.875L631.7 729.792L631 729.792L630.3 729.792L630.3 733.875L631 733.875ZM631 725.708L631.7 725.708L631.7 721.625L631 721.625L630.3 721.625L630.3 725.708L631 725.708ZM631 717.542L631.7 717.542L631.7 713.458L631 713.458L630.3 713.458L630.3 717.542L631 717.542ZM631 709.375L631.7 709.375L631.7 705.292L631 705.292L630.3 705.292L630.3 709.375L631 709.375ZM631 701.208L631.7 701.208L631.7 697.125L631 697.125L630.3 697.125L630.3 701.208L631 701.208ZM631 693.042L631.7 693.042L631.7 688.958L631 688.958L630.3 688.958L630.3 693.042L631 693.042ZM631 684.875L631.7 684.875L631.7 680.792L631 680.792L630.3 680.792L630.3 684.875L631 684.875ZM631 676.708L631.7 676.708L631.7 672.625L631 672.625L630.3 672.625L630.3 676.708L631 676.708ZM631 668.542L631.7 668.542L631.7 664.458L631 664.458L630.3 664.458L630.3 668.542L631 668.542ZM631 660.375L631.7 660.375L631.7 656.292L631 656.292L630.3 656.292L630.3 660.375L631 660.375ZM631 652.208L631.7 652.208L631.7 648.125L631 648.125L630.3 648.125L630.3 652.208L631 652.208ZM631 644.042L631.7 644.042L631.7 642L631 642L630.3 642L630.3 644.042L631 644.042ZM631 642L631 641.3L629.083 641.3L629.083 642L629.083 642.7L631 642.7L631 642ZM625.25 642L625.25 641.3L621.417 641.3L621.417 642L621.417 642.7L625.25 642.7L625.25 642ZM617.583 642L617.583 641.3L613.75 641.3L613.75 642L613.75 642.7L617.583 642.7L617.583 642ZM609.917 642L609.917 641.3L606.083 641.3L606.083 642L606.083 642.7L609.917 642.7L609.917 642ZM602.25 642L602.25 641.3L598.417 641.3L598.417 642L598.417 642.7L602.25 642.7L602.25 642ZM594.583 642L594.583 641.3L590.75 641.3L590.75 642L590.75 642.7L594.583 642.7L594.583 642ZM586.917 642L586.917 641.3L583.083 641.3L583.083 642L583.083 642.7L586.917 642.7L586.917 642ZM579.25 642L579.25 641.3L575.417 641.3L575.417 642L575.417 642.7L579.25 642.7L579.25 642ZM571.583 642L571.583 641.3L567.75 641.3L567.75 642L567.75 642.7L571.583 642.7L571.583 642ZM563.917 642L563.917 641.3L562 641.3L562 642L562 642.7L563.917 642.7L563.917 642ZM631 642L632.4 642L632.4 640.6L631 640.6L631 642ZM631 789L631 790.4L632.4 790.4L632.4 789L631 789ZM562 789L562 790.4L563.917 790.4L563.917 789L563.917 787.6L562 787.6L562 789ZM567.75 789L567.75 790.4L571.583 790.4L571.583 789L571.583 787.6L567.75 787.6L567.75 789ZM575.417 789L575.417 790.4L579.25 790.4L579.25 789L579.25 787.6L575.417 787.6L575.417 789ZM583.083 789L583.083 790.4L586.917 790.4L586.917 789L586.917 787.6L583.083 787.6L583.083 789ZM590.75 789L590.75 790.4L594.583 790.4L594.583 789L594.583 787.6L590.75 787.6L590.75 789ZM598.417 789L598.417 790.4L602.25 790.4L602.25 789L602.25 787.6L598.417 787.6L598.417 789ZM606.083 789L606.083 790.4L609.917 790.4L609.917 789L609.917 787.6L606.083 787.6L606.083 789ZM613.75 789L613.75 790.4L617.583 790.4L617.583 789L617.583 787.6L613.75 787.6L613.75 789ZM621.417 789L621.417 790.4L625.25 790.4L625.25 789L625.25 787.6L621.417 787.6L621.417 789ZM629.083 789L629.083 790.4L631 790.4L631 789L631 787.6L629.083 787.6L629.083 789ZM631 789L632.4 789L632.4 786.958L631 786.958L629.6 786.958L629.6 789L631 789ZM631 782.875L632.4 782.875L632.4 778.792L631 778.792L629.6 778.792L629.6 782.875L631 782.875ZM631 774.708L632.4 774.708L632.4 770.625L631 770.625L629.6 770.625L629.6 774.708L631 774.708ZM631 766.542L632.4 766.542L632.4 762.458L631 762.458L629.6 762.458L629.6 766.542L631 766.542ZM631 758.375L632.4 758.375L632.4 754.292L631 754.292L629.6 754.292L629.6 758.375L631 758.375ZM631 750.208L632.4 750.208L632.4 746.125L631 746.125L629.6 746.125L629.6 750.208L631 750.208ZM631 742.042L632.4 742.042L632.4 737.958L631 737.958L629.6 737.958L629.6 742.042L631 742.042ZM631 733.875L632.4 733.875L632.4 729.792L631 729.792L629.6 729.792L629.6 733.875L631 733.875ZM631 725.708L632.4 725.708L632.4 721.625L631 721.625L629.6 721.625L629.6 725.708L631 725.708ZM631 717.542L632.4 717.542L632.4 713.458L631 713.458L629.6 713.458L629.6 717.542L631 717.542ZM631 709.375L632.4 709.375L632.4 705.292L631 705.292L629.6 705.292L629.6 709.375L631 709.375ZM631 701.208L632.4 701.208L632.4 697.125L631 697.125L629.6 697.125L629.6 701.208L631 701.208ZM631 693.042L632.4 693.042L632.4 688.958L631 688.958L629.6 688.958L629.6 693.042L631 693.042ZM631 684.875L632.4 684.875L632.4 680.792L631 680.792L629.6 680.792L629.6 684.875L631 684.875ZM631 676.708L632.4 676.708L632.4 672.625L631 672.625L629.6 672.625L629.6 676.708L631 676.708ZM631 668.542L632.4 668.542L632.4 664.458L631 664.458L629.6 664.458L629.6 668.542L631 668.542ZM631 660.375L632.4 660.375L632.4 656.292L631 656.292L629.6 656.292L629.6 660.375L631 660.375ZM631 652.208L632.4 652.208L632.4 648.125L631 648.125L629.6 648.125L629.6 652.208L631 652.208ZM631 644.042L632.4 644.042L632.4 642L631 642L629.6 642L629.6 644.042L631 644.042ZM631 642L631 640.6L629.083 640.6L629.083 642L629.083 643.4L631 643.4L631 642ZM625.25 642L625.25 640.6L621.417 640.6L621.417 642L621.417 643.4L625.25 643.4L625.25 642ZM617.583 642L617.583 640.6L613.75 640.6L613.75 642L613.75 643.4L617.583 643.4L617.583 642ZM609.917 642L609.917 640.6L606.083 640.6L606.083 642L606.083 643.4L609.917 643.4L609.917 642ZM602.25 642L602.25 640.6L598.417 640.6L598.417 642L598.417 643.4L602.25 643.4L602.25 642ZM594.583 642L594.583 640.6L590.75 640.6L590.75 642L590.75 643.4L594.583 643.4L594.583 642ZM586.917 642L586.917 640.6L583.083 640.6L583.083 642L583.083 643.4L586.917 643.4L586.917 642ZM579.25 642L579.25 640.6L575.417 640.6L575.417 642L575.417 643.4L579.25 643.4L579.25 642ZM571.583 642L571.583 640.6L567.75 640.6L567.75 642L567.75 643.4L571.583 643.4L571.583 642ZM563.917 642L563.917 640.6L562 640.6L562 642L562 643.4L563.917 643.4L563.917 642Z"
              fill="#1A1A1A"
              mask="url(#path-21-inside-1_18284_196607)"
            />
          </g>
          <g id="lines_4">
            <path
              id="Vector_3"
              d="M512.7 625.7L512.7 764.3"
              stroke="#1A1A1A"
              strokeWidth={1.4}
              strokeLinecap="square"
            />
          </g>
          <g id="Frame 465">
            <path
              d="M336 236.7H688C694.241 236.7 699.3 241.759 699.3 248V404C699.3 410.241 694.241 415.3 688 415.3H336C329.759 415.3 324.7 410.241 324.7 404V248C324.7 241.759 329.759 236.7 336 236.7Z"
              stroke="#1A1A1A"
              strokeWidth={1.4}
            />
            <g id="Rich Text Block">
              <g id="Frame 483">
                <text
                  id="H2 Header"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Bold"
                  fontSize={24}
                  letterSpacing="0em"
                >
                  <tspan x={364.133} y={302.196}>
                    Alpha-Linolenic acid (ALA)
                  </tspan>
                </text>
                <text
                  id="H2 Header_2"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Regular"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={474.047} y={331.44}>
                    (Precursor)
                  </tspan>
                </text>
              </g>
              <g id="Sources: Flaxseeds, chia seeds, walnuts">
                <text
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={430.609} y={367.464}>
                    Flaxseeds, chia seeds, walnuts
                  </tspan>
                </text>
                <text
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Bold"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={364} y={367.464}>
                    Sources:{" "}
                  </tspan>
                </text>
              </g>
            </g>
          </g>
          <g id="Frame 466">
            <path
              d="M678.988 1020V1020.7H681C681.756 1020.7 682.493 1020.77 683.206 1020.92L683.341 1020.23C684.915 1020.54 686.378 1021.16 687.666 1022.02L687.278 1022.6C688.511 1023.43 689.572 1024.49 690.397 1025.72L690.978 1025.33C691.84 1026.62 692.459 1028.08 692.771 1029.66L692.085 1029.79C692.226 1030.51 692.3 1031.24 692.3 1032V1034H693V1038H692.3V1042H693V1046H692.3V1050H693V1054H692.3V1058H693V1062H692.3V1066H693V1070H692.3V1074H693V1078H692.3V1082H693V1086H692.3V1090H693V1094H692.3V1098H693V1102H692.3V1106H693V1110H692.3V1114H693V1118H692.3V1122H693V1126H692.3V1130H693V1134H692.3V1138H693V1142H692.3V1146H693V1150H692.3V1154H693V1158H692.3V1162H693V1166H692.3V1170H693V1174H692.3V1178H693V1182H692.3V1186H693V1190H692.3V1194H693V1198H692.3V1202H693V1206H692.3V1210H693V1214H692.3V1218H693V1222H692.3V1226H693V1230H692.3V1234H693V1238H692.3V1242H693V1246H692.3V1250H693V1254H692.3V1258H693V1262H692.3V1266H693V1270H692.3V1272C692.3 1272.76 692.226 1273.49 692.085 1274.21L692.771 1274.34C692.459 1275.92 691.84 1277.38 690.978 1278.67L690.397 1278.28C689.572 1279.51 688.511 1280.57 687.278 1281.4L687.666 1281.98C686.378 1282.84 684.915 1283.46 683.341 1283.77L683.206 1283.08C682.493 1283.23 681.756 1283.3 681 1283.3H678.988V1284H674.964V1283.3H670.94V1284H666.916V1283.3H662.893V1284H658.869V1283.3H654.845V1284H650.821V1283.3H646.798V1284H642.773V1283.3H638.75V1284H634.726V1283.3H630.702V1284H626.679V1283.3H622.654V1284H618.631V1283.3H614.607V1284H610.583V1283.3H606.56V1284H602.535V1283.3H598.512V1284H594.488V1283.3H590.464V1284H586.44V1283.3H582.417V1284H578.393V1283.3H574.369V1284H570.345V1283.3H566.321V1284H562.298V1283.3H558.273V1284H554.25V1283.3H550.227V1284H546.202V1283.3H542.179V1284H538.154V1283.3H534.131V1284H530.107V1283.3H526.083V1284H522.06V1283.3H518.036V1284H514.012V1283.3H509.988V1284H505.964V1283.3H501.94V1284H497.917V1283.3H493.893V1284H489.869V1283.3H485.846V1284H481.821V1283.3H477.798V1284H473.773V1283.3H469.75V1284H465.727V1283.3H461.702V1284H457.679V1283.3H453.655V1284H449.631V1283.3H445.607V1284H441.583V1283.3H437.56V1284H433.536V1283.3H429.512V1284H425.488V1283.3H421.464V1284H417.44V1283.3H413.417V1284H409.393V1283.3H405.369V1284H401.346V1283.3H397.321V1284H393.298V1283.3H389.273V1284H385.25V1283.3H381.227V1284H377.202V1283.3H373.179V1284H369.154V1283.3H365.131V1284H361.107V1283.3H357.083V1284H353.06V1283.3H349.036V1284H345.012V1283.3H343C342.244 1283.3 341.507 1283.23 340.794 1283.08L340.658 1283.77C339.084 1283.46 337.621 1282.84 336.333 1281.98L336.722 1281.4C335.489 1280.57 334.428 1279.51 333.603 1278.28L333.021 1278.67C332.16 1277.38 331.54 1275.92 331.229 1274.34L331.915 1274.21C331.809 1273.67 331.741 1273.12 331.714 1272.56L331.7 1272V1270H331V1266H331.7V1262H331V1258H331.7V1254H331V1250H331.7V1246H331V1242H331.7V1238H331V1234H331.7V1230H331V1226H331.7V1222H331V1218H331.7V1214H331V1210H331.7V1206H331V1202H331.7V1198H331V1194H331.7V1190H331V1186H331.7V1182H331V1178H331.7V1174H331V1170H331.7V1166H331V1162H331.7V1158H331V1154H331.7V1150H331V1146H331.7V1142H331V1138H331.7V1134H331V1130H331.7V1126H331V1122H331.7V1118H331V1114H331.7V1110H331V1106H331.7V1102H331V1098H331.7V1094H331V1090H331.7V1086H331V1082H331.7V1078H331V1074H331.7V1070H331V1066H331.7V1062H331V1058H331.7V1054H331V1050H331.7V1046H331V1042H331.7V1038H331V1034H331.7V1032C331.7 1031.24 331.774 1030.51 331.915 1029.79L331.229 1029.66C331.54 1028.08 332.16 1026.62 333.021 1025.33L333.603 1025.72C334.428 1024.49 335.489 1023.43 336.722 1022.6L336.333 1022.02C337.621 1021.16 339.084 1020.54 340.658 1020.23L340.794 1020.92C341.507 1020.77 342.244 1020.7 343 1020.7H345.012V1020H349.036V1020.7H353.06V1020H357.084V1020.7H361.107V1020H365.131V1020.7H369.155V1020H373.179V1020.7H377.202V1020H381.227V1020.7H385.25V1020H389.274V1020.7H393.298V1020H397.321V1020.7H401.346V1020H405.369V1020.7H409.393V1020H413.417V1020.7H417.44V1020H421.465V1020.7H425.488V1020H429.512V1020.7H433.536V1020H437.56V1020.7H441.583V1020H445.607V1020.7H449.631V1020H453.655V1020.7H457.679V1020H461.702V1020.7H465.727V1020H469.75V1020.7H473.773V1020H477.798V1020.7H481.821V1020H485.846V1020.7H489.869V1020H493.893V1020.7H497.917V1020H501.94V1020.7H505.964V1020H509.988V1020.7H514.012V1020H518.036V1020.7H522.06V1020H526.083V1020.7H530.107V1020H534.131V1020.7H538.154V1020H542.179V1020.7H546.202V1020H550.227V1020.7H554.25V1020H558.273V1020.7H562.298V1020H566.321V1020.7H570.345V1020H574.369V1020.7H578.393V1020H582.417V1020.7H586.44V1020H590.464V1020.7H594.488V1020H598.512V1020.7H602.536V1020H606.56V1020.7H610.583V1020H614.607V1020.7H618.631V1020H622.654V1020.7H626.679V1020H630.702V1020.7H634.727V1020H638.75V1020.7H642.773V1020H646.798V1020.7H650.821V1020H654.846V1020.7H658.869V1020H662.893V1020.7H666.917V1020H670.94V1020.7H674.964V1020H678.988Z"
              stroke="#5220DD"
              strokeWidth={1.4}
              strokeDasharray="4 4"
            />
            <g id="report-label">
              <g id="Report titles">
                <rect width={42} height={36} transform="translate(491 1060)" fill="white" />
                <text
                  id="25-Hydroxy Vitamin D"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Bold"
                  fontSize={24}
                  letterSpacing="0em"
                >
                  <tspan x={491.398} y={1086.2}>
                    EPA
                  </tspan>
                </text>
              </g>
              <g id="lines_5">
                <path
                  id="Vector_4"
                  d="M512.659 1100.7L512.659 1100L511.259 1100L511.259 1100.7L511.959 1100.7L512.659 1100.7ZM511.959 1170L516 1163L507.918 1163L511.959 1170ZM511.959 1100.7L511.259 1100.7L511.259 1163.7L511.959 1163.7L512.659 1163.7L512.659 1100.7L511.959 1100.7Z"
                  fill="#1A1A1A"
                />
              </g>
            </g>
            <g id="Report titles_2">
              <rect width={282} height={64} transform="translate(371 1180)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_2"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Bold"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={487.449} y={1206.2}>
                  DHA
                </tspan>
              </text>
              <g id="Sub label">
                <text
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Regular"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={480.422} y={1235.46}>
                    {" "}
                    Fatty fish, supplements
                  </tspan>
                </text>
                <text
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Bold"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={371.438} y={1235.46}>
                    Direct sources:
                  </tspan>
                </text>
              </g>
            </g>
          </g>
          <g id="Report titles_3">
            <rect width={138} height={28} transform="translate(657 704)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_3"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={18}
              letterSpacing="0em"
            >
              <tspan x={657.059} y={724.129}>
                Sequential order
              </tspan>
            </text>
          </g>
          <g id="Report titles_4">
            <rect width={42} height={20} transform="translate(400 626)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_4"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={400.48} y={640.086}>
                Phase 1
              </tspan>
            </text>
          </g>
          <g id="Report titles_5">
            <rect width={44} height={20} transform="translate(400 769)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_5"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={400.455} y={783.086}>
                Phase 2
              </tspan>
            </text>
          </g>
          <g id="gene-FADS2" {...geneGroupProps("FADS2", onGeneClick)}>
            <g id="gene-lozenge_5">
              <path
                d="M456 624C456 621.791 457.791 620 460 620H554C556.209 620 558 621.791 558 624V660C558 662.209 556.209 664 554 664H460C457.791 664 456 662.209 456 660V624Z"
                fill={fads2.lozengeFill}
              />
              <text
                id="gene-label_5"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={472.078} y={650.16}>
                  FADS2
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="fads2"
              groupId="gene-snps"
              genePalette={fads2}
              startX={464}
              startY={666}
              snpCount={getGeneSnpCount("FADS2", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-FADS1" {...geneGroupProps("FADS1", onGeneClick)}>
            <g id="gene-lozenge_6">
              <path
                d="M456 769C456 766.791 457.791 765 460 765H552C554.209 765 556 766.791 556 769V805C556 807.209 554.209 809 552 809H460C457.791 809 456 807.209 456 805V769Z"
                fill={fads1.lozengeFill}
              />
              <text
                id="gene-label_6"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={473.305} y={795.16}>
                  FADS1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="fads1"
              groupId="gene-snps_2"
              genePalette={fads1}
              startX={464}
              startY={811}
              snpCount={getGeneSnpCount("FADS1", expectedSnps, geneColors)}
            />
          </g>
        </g>
      </g>
    </>
  );
};

const SvgNutritionOmega3Diagram = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1024}
    height={1240}
    viewBox="0 176 1024 1240"
    fill="none"
    {...props}
  >
    <NutritionOmega3DiagramContent
      geneColors={geneColors}
      expectedSnps={expectedSnps}
      onGeneClick={onGeneClick}
    />
    <defs>
      <clipPath id="clip0_18284_196607">
        <rect width={1024} height={1416} fill="white" />
      </clipPath>
      <clipPath id="clip1_18284_196607">
        <rect width={1024} height={1240} fill="white" transform="translate(0 176)" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgNutritionOmega3Diagram;
